// The export endpoint filters by server-side calendar day (DATE(date)), so
// the preview count must compare day prefixes rather than instants: `date`
// arrives as a server-formatted `YYYY-MM-DD HH:mm:ss` string and from/to as
// UTC-midnight ISO strings (ACC-6588).
export const isWithinExportDays = (date, from, to) => {
    if (!from) {
        return true;
    }
    const day = date.slice(0, 10);
    const toDay = (to ?? new Date().toISOString()).slice(0, 10);
    return day >= from.slice(0, 10) && day <= toDay;
};
